// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2tQxR","addWidgetButton":"Header_addWidgetButton__EHlXc","dashboardTabs":"Header_dashboardTabs__1qj6j","active":"Header_active__blf4v"};